import type {
  TaskFrame,
  TrackResult,
} from "@labeling-tools/api/field-rep/generated/types.gen";
import { ProductProposal } from "@/types/trackLabeling";

export const canConfirmAssociation = ({
  selectedProduct,
  frameProducts,
}: {
  selectedProduct: string;
  frameProducts: ProductProposal[];
}): boolean => {
  return frameProducts.some(
    (productProposal) => productProposal.product_id === selectedProduct,
  );
};

export const buildAssociationResult = ({
  selectedProductId,
  trackId,
  effectiveEndFrame,
}: {
  selectedProductId: string;
  trackId: string;
  effectiveEndFrame: number;
}): TrackResult => ({
  product_id: selectedProductId,
  track_id: trackId,
  effective_end_frame: effectiveEndFrame,
});

export const buildProductNotListedResult = ({
  trackId,
  frames,
}: {
  trackId: string;
  frames: TaskFrame[];
}): TrackResult => ({
  product_id: null,
  track_id: trackId,
  // Every frame field without image_url field. Same shape as the backend TrackResult.
  frames: frames.map((frame) => ({
    image_id: frame.image_id,
    frame_index: frame.frame_index,
    points: frame.points,
    confidence: frame.confidence,
    product_proposals: frame.product_proposals,
  })),
});

export const buildBadDetectionResult = (trackId: string): TrackResult => ({
  product_id: null,
  track_id: trackId,
  status: "bad_detection",
});
